import Vue from 'vue'
import Router from 'vue-router'
import login from '../views/login/login.vue'
import foot from '../components/foot.vue'
import print from '../views/print/print.vue'
 
// import loading from '../components/loading'
import signIn from '../views/signIn/signIn.vue'
import forgetPassword from '../views/forgetPassword/forgetPassword.vue'
import personalData from '../views/personalData/personalData.vue'
import logoutApply from '../views/logoutApply/logoutApply.vue'
import logoutCannot from '../views/logoutCannot/logoutCannot.vue'
import logoutVerify from '../views/logoutVerify/logoutVerify.vue'
import more from '../views/more/more.vue'
import fullReduction from '../views/fullReduction/fullReduction.vue'
import contactUs from '../views/contactUs/contactUs.vue'
import companyProfile from '../views/companyProfile/companyProfile.vue'
import customization from '../views/customization/customization.vue'
import myVoucher from '../views/myVoucher/myVoucher.vue'
import getVoucher from '../views/getVoucher/getVoucher.vue'
import serve from '../views/serve/serve'
import moreFutureDevelopment from '../views/moreFutureDevelopment/moreFutureDevelopment.vue'
import myAddress from '../views/myAddress/myAddress.vue'
import shoppingCart from '../views/shoppingCart/shoppingCart.vue'
import personage from '../views/personage/personage.vue'
import submitOrder from '../views/submitOrder/submitOrder.vue'
import supplementalInvoice from '../views/supplementalInvoice/supplementalInvoice.vue'
import submitOrderSuccess from '../views/submitOrderSuccess/submitOrderSuccess.vue'
import paySuccess from '../views/paySuccess/paySuccess.vue'
import goodsDetail from '../views/goodsDetail/goodsDetail.vue'
import openInvoice from '../views/openInvoice/openInvoice.vue'
// 寻找设计
import design from '../views/design/design.vue'
// 我发布的需求
import myDesign from '../views/myDesign/myDesign.vue'
//新闻
import news from '../views/news/news.vue'
import newsDetail from '../views/newsDetail/newsDetail.vue'
import voucherActivit from '../views/voucherActivit/voucherActivit.vue'
import noteThat from '../views/noteThat/noteThat.vue'
import userAgreement from '../views/userAgreement/userAgreement.vue'
import stylistAgreement from '../views/stylistAgreement/stylistAgreement.vue'
import logoutAgreement from '../views/logoutAgreement/logoutAgreement.vue'
import afterSalesTerms from '../views/afterSalesTerms/afterSalesTerms.vue'
//积分
import integral from '../views/integral/integral.vue'
import myIssue from '../views/myIssue/myIssue.vue'
// import materialCompare from '../views/materialCompare/materialCompare'
import myOrder from '../views/myOrder/myOrder.vue'
import orderDetail from '../views/orderDetail/orderDetail.vue'
import home from '../views/home/home.vue'
import homePage from '../views/homePage/homePage.vue'
import classify from '../views/classify/classify.vue'
// 发布需求
import postDemand from '../views/postDemand/postDemand.vue'
//我的收藏
import myCollect from '../views/myCollect/myCollect.vue'
import designDetail from '../views/designDetail/designDetail.vue'
import afterClassify from '../views/afterClassify/afterClassify.vue'
import printedInstructions from '../views/printedInstructions/printedInstructions.vue'
import noPictureQuote from '../views/noPictureQuote/noPictureQuote.vue'
//商城
import shop from '../views/shop/shop.vue'
import channelApply from '../views/channelApply/channelApply.vue'
//设计师商城
import stylistStore from '../views/stylistStore/stylistStore.vue'
//商品详情
import commodity from '../views/commodity/commodity.vue'
import fullScreenVideo from '../views/fullScreenVideo/fullScreenVideo.vue'
//个人推广
import generalize from '../views/generalize/generalize.vue'
//发票信息
import invoiceInfo from '../views/invoiceInfo/invoiceInfo.vue'
//评价
import evaluate from '../views/evaluate/evaluate.vue'
// materialCompare

 
 
// 打印须知
import printNotice from '../views/printNotice/printNotice.vue'
// 材料对比
import contrastMaterial from '../views/contrastMaterial/contrastMaterial.vue'
// 月结申请
import monthly from '../views/monthly/monthly.vue'
// 申请设计师
import stylist from '../views/stylist/stylist.vue'

//我的店铺
import myStore from '../views/myStore/myStore.vue'
//店铺子路由
import storeInfo from '../views/myStore/storeInfo/storeInfo.vue'
import productList from '../views/myStore/productList/productList.vue'
import sellOrders from '../views/myStore/sellOrders/sellOrders.vue'
import productUpload from '../views/myStore/productUpload/productUpload.vue'

import loginTransfers from '../views/loginTransfers/loginTransfers.vue'
import thirdPartyLogin from '../views/thirdPartyLogin/thirdPartyLogin.vue'

// 彩色浮雕
import reliefPhoto from '../views/reliefPhoto/reliefPhoto.vue'
// 3D浮雕
import reliefOrnaments from '../views/reliefOrnaments/reliefOrnaments.vue'
// 3D手机壳
import mobilPhoneShell3d from '../views/mobilPhoneShell3d/mobilPhoneShell3d.vue'
// 3D收纳盒
import box3d from '../views/box3d/box3d.vue'
// 3D竹筒
import bamboo3d from '../views/bamboo3d/bamboo3d.vue'
// 3D文字
import word3d from '../views/word3d/word3d.vue'
// 灯罩
import lampshade3d from '../views/lampshade3d/lampshade3d.vue'
// 人头像
import headPortrait3d from '../views/headPortrait3d/headPortrait3d.vue'
// 花瓶
import vase3d from '../views/vase3d/vase3d.vue'
// 3D标识牌
import signText from '../views/signText/signText.vue'
// 浮雕圆筒
import reliefCylinder from '../views/reliefCylinder/reliefCylinder.vue'
// 浮雕盒子
import reliefBox from '../views/reliefBox/reliefBox.vue'
// 定制花瓶
import reliefVase from '../views/reliefVase/reliefVase.vue'
// 剪纸灯
import papercutLamp from '../views/papercutLamp/papercutLamp.vue'
// 装饰画
import decorativePainting from '../views/decorativePainting/decorativePainting.vue'
// 笔筒
import penholder from '../views/penholder/penholder.vue'
// 定制首饰挂件
import jewelryPendant from '../views/jewelryPendant/jewelryPendant.vue'
// 树形首饰挂件
import makeLeaf from '../views/makeLeaf/makeLeaf.vue'

// 泰森纹笔筒
import tysonPenHolder from '../views/makeTysonPenHolder/tysonPenHolder.vue'
// 随机voronoi摆件
import makeVoroStand from '../views/makeVoroStand/makeVoroStand.vue'
// 多面体摆件
import makePolyhedronStand from '../views/makePolyhedronStand/makePolyhedronStand.vue'
// 斜式笔筒
import makePenContainer from '../views/makePenContainer/makePenContainer.vue'
// 竹蜻蜓
import makeFlyToy from '../views/makeFlyToy/makeFlyToy.vue'
// 二维码
import makeQRCode from '../views/makeQRCode/makeQRCode.vue'



import collectCoupons from '../views/collectCoupons/collectCoupons.vue'
// 涂鸦
// import Doodle3D from '../views/doodle3d/Doodle3D.vue'
// 3D二维码
// import qrCode from '../views/qrCode/qrCode.vue'
// 3D七巧板
// import neves3d from '../views/neves3d/neves3d.vue'
// 3D摆pose
// import pose from '../views/pose/pose.vue'
// 3D二维像素画
// import modeEditor from '../views/modeEditor/modeEditor.vue'
// 3D象棋
// import chineseChess from '../views/chineseChess/chineseChess.vue'
// 3D地形图
// import earth3d from '../views/earth3d/earth3d.vue'
// 游戏
// import youxi from '../views/youxi/youxi.vue'
// 3D手掌
// import palm from '../views/palm/palm.vue'
// 3D几何体
// import geometry from '../views/geometry/geometry.vue'
// 3D挪车电话
// import mobilephone from '../views/mobilephone/mobilephone.vue'//命名方式不能有大写字母
// 3D挪车电话页面里面的编辑页面
// import editstyle from '../views/mobilephone/editStyle.vue'



// 过年放假通知
import yearNotice from '../views/yearNotice/yearNotice.vue'
// 行业案例
import casus from '../views/case/case.vue'

// 行业案例
import caseInfo from '../views/caseInfo/caseInfo.vue'
// 视频
import video from '../views/video/video.vue'
import videoInfo from '../views/videoInfo/videoInfo.vue'
import sla from '../views/sla/sla.vue'
import sls from '../views/sls/sls.vue'
import fdm from '../views/fdm/fdm.vue'
import mjf from '../views/mjf/mjf.vue'
import slm from '../views/slm/slm.vue'
import materials from '../views/materials/materials.vue'
import surface from '../views/surface/surface.vue'
import designGuide from '../views/designGuide/designGuide.vue'
import commission from '../views/commission/commission.vue'
import drawMoney from '../views/drawMoney/drawMoney.vue'
import activity from '../views/activity/activity.vue'
console.log(sla);
Vue.use(Router)

export default new Router({
  // mode:'history',
  routes: [
    //首页
    {
      path: '/',
      name: 'homePage',
      component: homePage,
      meta: {
        showFoot: true,
        moduleName: "首页-齐思印",
        belong: '/'
      }
    },
    // {
    //   path: '/activity',
    //   name: 'activity',
    //   component: activity,
    //   meta: {
    //     showFoot: true,
    //     moduleName: "双十一活动",
    //     belong: '/'
    //   }
    // },
    
    //商城
    {
      path: '/shop',
      name: 'shop',
      component: shop,
      meta: {
        showFoot: true,
        moduleName: "产品中心-3D打印商城",
        belong: 'shop',
        keepAlive: true
      }
    },
    //设计师商城
    {
      path: '/stylistStore',
      name: 'stylistStore',
      component: stylistStore,
      meta: {
        showFoot: true,
        moduleName: "产品中心-设计师店铺",
        belong: 'shop'
        // requireLogin: true
      }
    },
    //商品详情
    {
      path: '/commodity',
      name: 'commodity',
      component: commodity,
      meta: {
        showFoot: true,
        moduleName: "产品中心-商品详情",
        belong: 'shop'
      }
    },
    {
      path: '/fullScreenVideo',
      name: 'fullScreenVideo',
      component: fullScreenVideo,
      meta: {
        isNviewBox: true,
        showFoot: false,
        moduleName: "产品中心-商品详情",
        belong: 'shop'
      }
    },
    //评价
    {
      path: '/evaluate',
      name: 'evaluate',
      component: evaluate,
      meta: {
        showFoot: true,
        moduleName: "其他-订单评价",
        belong: 'mine'
      }
    },
    // {
    //   path: '/',
    //   name: 'design',
    //   component: design,
    //   meta: {
    //     showFoot: true
    //   }
    // },
    {
      path: '/design',
      name: 'design',
      component: design,
      meta: {
        showFoot: true,
        moduleName: "设计-寻找设计",
        belong: 'design'
      }
    },
    // 打印
    {
      path: '/print',
      name: 'print',
      component: print,
      meta: {
        keepAlive: true,
        moduleName: "打印-3D打印在线报价",
        showFoot: true,
        belong: 'print'
      }
    },
    // 登录
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        showFoot: false,
        moduleName: "其他-登录",
        isNviewBox: true
      }
    },
    // 底部公共组件
    {
      path: '/foot',
      name: 'foot',
      component: foot
    }, 
    // {
    //   path: '/loading',
    //   name: 'loading',
    //   component: loading
    // },
    {
      path: '/signIn',
      name: 'signIn',
      component: signIn,
      meta: {
        showFoot: false,
        moduleName: "其他-注册",
        isNviewBox: true
      }
    },
    {
      path: '/forgetPassword',
      name: 'forgetPassword',
      component: forgetPassword,
      meta: {
        showFoot: false,
        moduleName: "其他-找回密码",
        isNviewBox: true
      }
    },
    {
      path: '/personalData',
      name: 'personalData',
      component: personalData,
      meta: {
        showFoot: true,
        moduleName: "其他-个人信息",
        isNviewBox: true,
        requireLogin: true,
        belong: 'mine'
      }
    },
    {
      path: '/logoutApply',
      name: 'logoutApply',
      component: logoutApply,
      meta: {
        showFoot: false,
        moduleName: "其他-账号注销",
        isNviewBox: true,
        requireLogin: true,
        // belong: 'mine'
      }
    },
    {
      path: '/logoutCannot',
      name: 'logoutCannot',
      component: logoutCannot,
      meta: {
        showFoot: false,
        moduleName: "其他-账号注销",
        isNviewBox: true,
        requireLogin: true,
        // belong: 'mine'
      }
    },
    {
      path: '/logoutVerify',
      name: 'logoutVerify',
      component: logoutVerify,
      meta: {
        showFoot: true,
        moduleName: "其他-账号注销",
        // isNviewBox: true,
        requireLogin: true,
        // belong: 'mine'
      }
    },
    //更多
    {
      path: '/more',
      name: 'more',
      component: more,
      meta: {
        showFoot: true,
      }
    },
    //满减活动
    {
      path: '/fullReduction',
      name: 'fullReduction',
      component: fullReduction,
      meta: {
        showFoot: true,
        moduleName: "其他-满减活动",
      }
    },
    //联系我们
    {
      path: '/contactUs',
      name: 'contactUs',
      component: contactUs,
      meta: {
        showFoot: true,
        moduleName: "其他-联系我们",
      }
    },
    //公司简介
    {
      path: '/companyProfile',
      name: 'companyProfile',
      component: companyProfile,
      meta: {
        showFoot: true,
        moduleName: "其他-公司简介",
      }
    },
    //3D小软件
    {
      path: '/customization',
      name: 'customization',
      component: customization,
      meta: {
        showFoot: true,
        moduleName: "3D小软件-创意小软件",
        belong: 'customization'
      }
    },
    //我的代金券
    {
      path: '/myVoucher',
      name: 'myVoucher',
      component: myVoucher,
      meta: {
        showFoot: true,
        moduleName: "其他-我的代金券",
      }
    },
    //领取代金券
    {
      path: '/getVoucher',
      name: 'getVoucher',
      component: getVoucher,
      meta: {
        showFoot: true,
        moduleName: "其他-领取代金券",
      }
    },
    //服务介绍
    {
      path: '/serve',
      name: 'serve',
      component: serve,
      meta: {
        showFoot: true,
        moduleName: "其他-服务介绍",
      }
    },
    {
      path: '/moreFutureDevelopment',
      name: 'moreFutureDevelopment',
      component: moreFutureDevelopment,
      meta: {
        showFoot: true,
        moduleName: "其他-未来发展",
      }
    },
    {
      path: '/myAddress',
      name: 'myAddress',
      component: myAddress,
      meta: {
        showFoot: false,
        moduleName: "其他-收货地址管理",
        requireLogin: true
      }
    },
    {
      path: '/channelApply',
      name: 'channelApply',
      component: channelApply,
      meta: {
        requireLogin: true,
        moduleName: "产品中心-渠道用户申请",
        showFoot: true,
      }
    },
    //购物车
    {
      path: '/shoppingCart',
      name: 'shoppingCart',
      component: shoppingCart,
      meta: {
        showFoot: true,
        moduleName: "其他-购物车",
        requireLogin: true
      }
    },
    {
      path: '/personage',
      name: 'personage',
      component: personage,
      meta: {
        showFoot: true,
        requireLogin: true,
        belong: 'mine'
      }
    },
    {
      path: '/submitOrder',
      name: 'submitOrder',
      component: submitOrder,
      meta: {
        showFoot: true,
        moduleName: "其他-提交订单",
        requireLogin: true,
        index: 1,
      },
    },
    {
      path: '/supplementalInvoice',
      name: 'supplementalInvoice',
      component: supplementalInvoice,
      meta: {
        showFoot: false,
        moduleName: "其他-补开发票",
        requireLogin: true
      },
    },
    {
      path: '/submitOrderSuccess',
      name: 'submitOrderSuccess',
      component: submitOrderSuccess,
      meta: {
        showFoot: true,
        moduleName: "其他-待付款",
        index: 2,
        requireLogin: true
      },
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: paySuccess,
      meta: {
        showFoot: true,
        moduleName: "其他-支付成功",
        requireLogin: true
      }
    },
    {
      path: '/goodsDetail',
      name: 'goodsDetail',
      component: goodsDetail,
      meta: {
        showFoot: false,

      }
    },
    {
      path: '/myDesign',
      name: 'myDesign',
      component: myDesign,
      meta: {
        showFoot: true,
        moduleName: "设计-设计任务",
        requireLogin: true
      }
    },
    {
      path: '/news',
      name: 'news',
      component: news,
      meta: {
        showFoot: true,
        moduleName: "其他-新闻资讯",
      }
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail,
      meta: {
        showFoot: true,
        moduleName: "其他-新闻资讯",
      }
    },
    {
      path: '/voucherActivit',
      name: 'voucherActivit',
      component: voucherActivit,
      meta: {
        showFoot: true,
        moduleName: "其他-代金券公告",
      }
    },
    {
      path: '/noteThat',
      name: 'noteThat',
      component: noteThat,
      meta: {
        showFoot: true,
        moduleName: "其他-发票说明",
      }
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: userAgreement,
      meta: {
        showFoot: true,
        moduleName: "其他-用户协议",
      }
    },
    {
      path: '/stylistAgreement',
      name: 'stylistAgreement',
      component: stylistAgreement,
      meta: {
        showFoot: true,
        moduleName: "其他-设计师协议",
      }
    },
    {
      path: '/logoutAgreement',
      name: 'logoutAgreement',
      component: logoutAgreement,
      meta: {
        showFoot: true,
        moduleName: "其他-注销须知",
      }
    },
    {
      path: '/afterSalesTerms',
      name: 'afterSalesTerms',
      component: afterSalesTerms,
      meta: {
        showFoot: true,
        moduleName: "其他-售后条款",
      }
    },
    {
      path: '/integral',
      name: 'integral',
      component: integral,
      meta: {
        showFoot: true,
        // moduleName: "其他-售后条款",
        requireLogin: true
      }
    },
    {
      path: '/generalize',
      name: 'generalize',
      component: generalize,
      meta: {
        showFoot: true,
        moduleName: "其他-个人推广",
        requireLogin: true
      }
    },
    {
      path: '/invoiceInfo',
      name: 'invoiceInfo',
      component: invoiceInfo,
      meta: {
        showFoot: true,
        moduleName: "其他-发票信息",
        requireLogin: true
      }
    },
    {
      path: '/myIssue',
      name: 'myIssue',
      component: myIssue,
      meta: {
        showFoot: true,
        moduleName: "设计-已发布的需求",
        requireLogin: true
      }
    },
    // 材料对比
    // {
    //   path: '/materialCompare',
    //   name: 'materialCompare',
    //   component: materialCompare
    // },
    {
      path: '/myOrder',
      name: 'myOrder',
      component: myOrder,
      meta: {
        showFoot: true,
        moduleName: "设计-我的订单",
        requireLogin: true,
        keepAlive: true
      }
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: orderDetail,
      meta: {
        showFoot: true,
        moduleName: "其他-订单详情",
        requireLogin: true
      }
    },
    {
      path: '/classify',
      name: 'classify',
      component: classify,
      meta: {
        showFoot: false,
        // moduleName: "其他-订单详情",
        index: 1
      }
    },
    {
      path: '/postDemand',
      name: 'postDemand',
      component: postDemand,
      meta: {
        showFoot: true,
        moduleName: "设计-发布需求",
        isNviewBox: true,
        // requireLogin: true
      }
    },
    {
      path: '/myCollect',
      name: 'myCollect',
      component: myCollect,
      meta: {
        showFoot: true,
        moduleName: "其他-我的收藏",
        requireLogin: true
      }
    },
    {
      path: '/designDetail',
      name: 'designDetail',
      component: designDetail,
      meta: {
        showFoot: false,
        // moduleName: "其他-我的收藏",
      }
    },
    {
      path: '/afterClassify',
      name: 'afterClassify',
      component: afterClassify,
      meta: {
        showFoot: false,
        // moduleName: "其他-我的收藏",
      }
    },
    {
      path: '/printedInstructions',
      name: 'printedInstructions',
      component: printedInstructions,
      meta: {
        showFoot: false,
        // moduleName: "其他-我的收藏",
      }
    },
    {
      path: '/noPictureQuote',
      name: 'noPictureQuote',
      component: noPictureQuote,
      meta: {
        showFoot: false
      }
    },
    {
      path: '/printNotice',
      name: 'printNotice',
      component: printNotice,
      meta: {
        showFoot: true,
        moduleName: "打印-打印须知",
      }
    },
    {
      path: '/contrastMaterial',
      name: 'contrastMaterial',
      component: contrastMaterial,
      meta: {
        showFoot: true,
        moduleName: "打印-材料对比",
      }
    },
    {
      path: '/monthly',
      name: 'monthly',
      component: monthly,
      meta: {
        showFoot: false,
        moduleName: "其他-月结申请",
        requireLogin: true,
      }
    },
    {
      path: '/stylist',
      name: 'stylist',
      component: stylist,
      meta: {
        showFoot: true,
        moduleName: "设计-设计师申请",
        requireLogin: true,
      }
    },
    {
      path: '/myStore',
      // name: 'myStore',
      component: myStore,
      meta: {
        showFoot: true,
        // moduleName: "产品中心-店铺管理",
        requireLogin: true
      },
      children: [
        {
          path: '/',
          name: 'storeInfo',
          component: storeInfo,
          meta: {
            showFoot: true,
            moduleName: "产品中心-店铺管理",
            requireLogin: true
          },
        },
        {
          path: '/myStore/productList',
          name: 'productList',
          component: productList,
          meta: {
            showFoot: true,
            moduleName: "产品中心-产品列表",
            requireLogin: true
          },
        },
        {
          path: '/myStore/sellOrders',
          name: 'sellOrders',
          component: sellOrders,
          meta: {
            showFoot: true,
            moduleName: "产品中心-卖出订单",
            requireLogin: true
          },
        },
        {
          path: '/myStore/productUpload',
          name: 'productUpload',
          component: productUpload,
          meta: {
            // showFoot: true,
            // isNviewBox: true,
            moduleName: "产品中心-产品上传",
            requireLogin: true
          },
        },
      ]
    },
    // {
    //   path: '/doodle3d',
    //   name: 'Doodle3D',
    //   component: Doodle3D,
    //   meta: {
    //     showFoot: true,
    //     moduleName: "3D小软件-创意小软件",
    //     requireLogin: false,
    //   }
    // },
    {
      path: '/loginTransfers',
      name: 'loginTransfers',
      component: loginTransfers,
      meta: {
        showFoot: true,
        requireLogin: false,
        // moduleName: "产品中心-卖出订单",
        // requireLogin: true
      },
    },
    // {
    //   path: '*',
    //   redirect: '/loginTransfers',
    // },
    {
      path: '/thirdPartyLogin',
      name: 'thirdPartyLogin',
      component: thirdPartyLogin,
      meta: {
        showFoot: false,
        // moduleName: "其他-登录",
        isNviewBox: true
      }
    },
    {
      path: '/signText3d',
      name: 'signText',
      component: signText,
      meta: {
        showFoot: false,
        moduleName: "3D小软件-3D标识牌",
        isNviewBox: true
      }
    },
    // {
    //   path: '/qrCode',
    //   name: 'qrCode',
    //   component: qrCode,
    //   meta: {
    //     showFoot: true,
    //     // moduleName: "其他-登录",
    //     isNviewBox: true
    //   }
    // },
    {
      path: '/box3d',
      name: 'box3d',
      component: box3d,
      meta: {
        showFoot: true,
        moduleName: "3D小软件-3D收纳盒",
        isNviewBox: true,
        // keepAlive: true,
        // belong: 'box3d'
      }
    },
    // {
    //   path: '/neves3d',
    //   name: 'neves3d',
    //   component: neves3d,
    //   meta: {
    //     showFoot: true,
    //     moduleName: "3D小软件-3D七巧板",
    //     isNviewBox: true,
    //   }
    // },
    // {
    //   path: '/pose',
    //   name: 'pose',
    //   component: pose,
    //   meta: {
    //     showFoot: true,
    //     // moduleName: "其他-登录",
    //     isNviewBox: true
    //   }
    // },
    {
      path: '/bamboo3d',
      name: 'bamboo3d',
      component: bamboo3d,
      meta: {
        showFoot: false,
        moduleName: "3D小软件-3D竹简",
        isNviewBox: true
      }
    },
    // {
    //   path: '/modeEditor',
    //   name: 'modeEditor',
    //   component: modeEditor,
    //   meta: {
    //     showFoot: true,
    //     moduleName: "3D小软件-3D像素画",
    //     isNviewBox: true
    //   }
    // },
    // {
    //   path: '/chineseChess',
    //   name: 'chineseChess',
    //   component: chineseChess,
    //   meta: {
    //     showFoot: true,
    //     // moduleName: "其他-登录",
    //     isNviewBox: true
    //   }
    // },
    {
      path: '/word3d',
      name: 'word3d',
      component: word3d,
      meta: {
        showFoot: false,
        moduleName: "3D小软件-3D文字",
        isNviewBox: true
      }
    }, {
      path: '/reliefOrnaments3d',
      name: 'reliefOrnaments',
      component: reliefOrnaments,
      meta: {
        showFoot: true,
        moduleName: "3D小软件-浮雕摆件",
        isNviewBox: true
      }
    },
    {
      path: '/reliefPhoto3d',
      name: 'reliefPhoto',
      component: reliefPhoto,
      meta: {
        showFoot: true,
        moduleName: "3D小软件-浮雕相框",
        isNviewBox: true
      }
    },
    // {
    //   path: '/earth3d',
    //   name: 'earth3d',
    //   component: earth3d,
    //   meta: {
    //     showFoot: true,
    //     moduleName: "3D小软件-3D地形图",
    //     isNviewBox: true
    //   }
    // },
    // {
    //   path: '/youxi',
    //   name: 'youxi',
    //   component: youxi,
    //   meta: {
    //     showFoot: true,
    //     // moduleName: "其他-登录",
    //     isNviewBox: true
    //   }
    // },
    // {
    //   path: '/palm',
    //   name: 'palm',
    //   component: palm,
    //   meta: {
    //     showFoot: true,
    //     // moduleName: "其他-登录",
    //     isNviewBox: true
    //   }
    // },
    // {
    //   path: '/geometry',
    //   name: 'geometry',
    //   component: geometry,
    //   meta: {
    //     showFoot: true,
    //     moduleName: "3D小软件-3D几何体",
    //     isNviewBox: true
    //   }
    // },
    // {
    //   path: '/mobilephone',
    //   name: 'mobilephone',
    //   component: mobilephone,
    //   meta: {
    //     showFoot: true,
    //     moduleName: "3D小软件-3D挪车电话",
    //     isNviewBox: true
    //   }
    // },
    {
      path: '/lampshade3d',
      name: 'lampshade3d',
      component: lampshade3d,
      meta: {
        showFoot: false,
        moduleName: "3D小软件-3D创意灯罩",
        isNviewBox: true
      }
    },
    {
      path: '/headPortrait3d',
      name: 'headPortrait3d',
      component: headPortrait3d,
      meta: {
        showFoot: false,
        moduleName: "3D小软件-3D人头像",
        isNviewBox: true
      }
    },
    {
      path: '/reliefCylinder3d',
      name: 'reliefCylinder',
      component: reliefCylinder,
      meta: {
        showFoot: false,
        moduleName: "3D小软件-浮雕圆筒",
        isNviewBox: true
      }
    },
    {
      path: '/reliefBox3d',
      name: 'reliefBox',
      component: reliefBox,
      meta: {
        showFoot: true,
        moduleName: "3D小软件-浮雕盒子",
        isNviewBox: true
      }
    },  
    {
      path: '/reliefVase',
      name: 'reliefVase',
      component: reliefVase,
      meta: {
        showFoot: false,
        moduleName: "3D小软件-定制花瓶",
        isNviewBox: true
      }
    },
    {
      path: '/papercutLamp',
      name: 'papercutLamp',
      component: papercutLamp,
      meta: {
        showFoot: false,
        moduleName: "3D小软件-定制剪纸灯",
        isNviewBox: true
      }
    },
    {
      path: '/decorativePainting',
      name: 'decorativePainting',
      component: decorativePainting,
      meta: {
        showFoot: true,
        moduleName: "3D小软件-定制装饰画",
        isNviewBox: true
      }
    },
    {
      path: '/penholder',
      name: 'penholder',
      component: penholder,
      meta: {
        showFoot: true,
        moduleName: "3D小软件-定制笔筒",
        isNviewBox: true
      }
    },
    {
      path: '/jewelryPendant',
      name: 'jewelryPendant',
      component: jewelryPendant,
      meta: {
        showFoot: true,
        moduleName: "3D小软件-定制首饰挂件",
        isNviewBox: true
      }
    },
    {
      path: '/vase3d',
      name: 'vase3d',
      component: vase3d,
      meta: {
        showFoot: true,
        moduleName: "3D小软件-3D花瓶",
        isNviewBox: true
      }
    },
    {
      path: '/mobilPhoneShell3d',
      name: 'mobilPhoneShell3d',
      component: mobilPhoneShell3d,
      meta: {
        showFoot: true,
        moduleName: "3D小软件-3D手机壳",
        isNviewBox: true
      }
    },
    {
      path: '/makeLeaf',
      name: 'makeLeaf',
      component: makeLeaf,
      meta: {
        showFoot: false,
        moduleName: "3D小软件-树形首饰挂件",
        isNviewBox: true
      }
    },{
      path: '/tysonPenHolder',
      name: 'tysonPenHolder',
      component: tysonPenHolder,
      meta: {
        showFoot: false,
        moduleName: "3D小软件-泰森纹笔筒",
        isNviewBox: true
      }
    },{
      path: '/makeVoroStand',
      name: 'makeVoroStand',
      component: makeVoroStand,
      meta: {
        showFoot: false,
        moduleName: "3D小软件-随机Voronoi摆件",
        isNviewBox: true
      }
    },{
      path: '/makePolyhedronStand',
      name: 'makePolyhedronStand',
      component: makePolyhedronStand,
      meta: {
        showFoot: false,
        moduleName: "3D小软件-多面体摆件",
        isNviewBox: true
      }
    },{
      path: '/makePenContainer',
      name: 'makePenContainer',
      component: makePenContainer,
      meta: {
        showFoot: false,
        moduleName: "3D小软件-斜式笔筒",
        isNviewBox: true
      }
    },{
      path: '/makeFlyToy',
      name: 'makeFlyToy',
      component: makeFlyToy,
      meta: {
        showFoot: false,
        moduleName: "3D小软件-竹蜻蜓",
        isNviewBox: true
      }
    },{
      path: '/makeQRCode',
      name: 'makeQRCode',
      component: makeQRCode,
      meta: {
        showFoot: false,
        moduleName: "3D小软件-二维码",
        isNviewBox: true
      }
    },
    {
      path: '/yearNotice',
      name: 'yearNotice',
      component: yearNotice,
      meta: {
        showFoot: true,
        // moduleName: "其他-登录",
        isNviewBox: true
      }
    },
    {
      path: '/case',
      name: 'case',
      component: casus,
      meta: {
        showFoot: true,
      }
    },
    {
      path: '/caseInfo',
      name: 'caseInfo',
      component: caseInfo,
      meta: {
        showFoot: true,
      }
    },
    {
      path: '/video',
      name: 'video',
      component: video,
      meta: {
        showFoot: true,
      }
    },
    {
      path: '/videoInfo',
      name: 'videoInfo',
      component: videoInfo,
      meta: {
        showFoot: true,
      }
    },
    {
      path: '/sla',
      name: 'sla',
      component: sla,
      meta: {
        showFoot: true,
        moduleName: "其他-sla",
      }
    },
    {
      path: '/sls',
      name: 'sls',
      component: sls,
      meta: {
        showFoot: true,
        moduleName: "其他-sls",
      }
    },
    {
      path: '/fdm',
      name: 'fdm',
      component: fdm,
      meta: {
        showFoot: true,
        moduleName: "其他-fdm",
      }
    },
    {
      path: '/mjf',
      name: 'mjf',
      component: mjf,
      meta: {
        showFoot: true,
        moduleName: "其他-mjf",
      }
    },
    {
      path: '/slm',
      name: 'slm',
      component: slm,
      meta: {
        showFoot: true,
        moduleName: "其他-slm",
      }
    },
    {
      path: '/materials',
      name: 'materials',
      component: materials,
      meta: {
        showFoot: true,
      }
    },
    {
      path: '/surface',
      name: 'surface',
      component: surface,
      meta: {
        showFoot: true,
      }
    },
    {
      path: '/designGuide',
      name: 'designGuide',
      component: designGuide,
      meta: {
        showFoot: true,
      }
    },
    {
      path: '/commission',
      name: 'commission',
      component: commission,
      meta: {
        showFoot: false,
      }
    },
    {
      path: '/drawMoney',
      name: 'drawMoney',
      component: drawMoney,
      meta: {
        showFoot: false,
      }
    },
    {
      path: '/openInvoice',
      name: 'openInvoice',
      component: openInvoice,
      meta: {
        showFoot: false,
      }
    }, 
    {
      path: '/invoiceEditing',
      name: 'invoiceEditing',
      component: () => import('../views/invoiceEditing/index.vue'),
      meta: {
        showFoot: false,
      },
      
 
    }, 
    {
      path: '/requestInvoice',
      name: 'requestInvoice',
 
      component: () => import('../views/requestInvoice/index.vue'),
      meta: {
        showFoot: false,
      },
      
 
    }, 
  


    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js